import { Country } from "../constants";

export const CountryLabelsForJa: Record<Country, string> = {
  jpn: "日本",
  usa: "アメリカ合衆国",
  gbr: "イギリス",
  ita: "イタリア",
  can: "カナダ",
  deu: "ドイツ",
  fra: "フランス",
  kor: "大韓民国",
  twn: "台湾",
  isl: "アイスランド",
  irl: "アイルランド",
  aze: "アゼルバイジャン",
  asm: "アメリカ領サモア",
  vir: "アメリカ領ヴァージン諸島",
  are: "アラブ首長国連邦",
  dza: "アルジェリア",
  arg: "アルゼンチン",
  alb: "アルバニア",
  arm: "アルメニア",
  aia: "アンギラ",
  atg: "アンティグア・バーブーダ",
  and: "アンドラ",
  yem: "イエメン",
  vgb: "イギリス領ヴァージン諸島",
  isr: "イスラエル",
  irq: "イラク",
  irn: "イラン・イスラム共和国",
  ind: "インド",
  idn: "インドネシア",
  wlf: "ウォリス・フツナ",
  uga: "ウガンダ",
  ukr: "ウクライナ",
  uzb: "ウズベキスタン",
  ury: "ウルグアイ",
  ecu: "エクアドル",
  egy: "エジプト",
  est: "エストニア",
  eth: "エチオピア",
  eri: "エリトリア",
  slv: "エルサルバドル",
  omn: "オマーン",
  nld: "オランダ",
  aus: "オーストラリア",
  aut: "オーストリア",
  ala: "オーランド諸島",
  kaz: "カザフスタン",
  qat: "カタール",
  cmr: "カメルーン",
  khm: "カンボジア",
  cpv: "カーボベルデ",
  guy: "ガイアナ",
  gab: "ガボン",
  gmb: "ガンビア",
  gha: "ガーナ",
  ggy: "ガーンジー",
  cyp: "キプロス",
  cuw: "キュラソー",
  cub: "キューバ",
  kir: "キリバス",
  kgz: "キルギスタン",
  gin: "ギニア",
  gnb: "ギニアビサウ",
  grc: "ギリシャ",
  kwt: "クウェート",
  cok: "クック諸島",
  cxr: "クリスマス島",
  hrv: "クロアチア",
  gtm: "グアテマラ",
  glp: "グアドループ",
  gum: "グアム",
  grl: "グリーンランド",
  grd: "グレナダ",
  cym: "ケイマン諸島",
  ken: "ケニア",
  cck: "ココス（キーリング）諸島",
  cri: "コスタリカ",
  com: "コモロ",
  col: "コロンビア",
  cog: "コンゴ共和国",
  cod: "コンゴ民主共和国",
  civ: "コートジボワール",
  sau: "サウジアラビア",
  sgs: "サウスジョージア・サウスサンドウィッチ諸島",
  wsm: "サモア",
  stp: "サントメ・プリンシペ",
  spm: "サンピエール島・ミクロン島",
  smr: "サンマリノ",
  blm: "サン・バルテルミー",
  maf: "サン・マルタン（フランス領）",
  zmb: "ザンビア",
  sle: "シエラレオネ",
  syr: "シリア・アラブ共和国",
  sgp: "シンガポール",
  sxm: "シント・マールテン（オランダ領）",
  dji: "ジブチ",
  gib: "ジブラルタル",
  jam: "ジャマイカ",
  jey: "ジャージー",
  geo: "ジョージア",
  zwe: "ジンバブエ",
  che: "スイス",
  swe: "スウェーデン",
  sjm: "スバールバル諸島およびヤンマイエン島",
  esp: "スペイン",
  sur: "スリナム",
  lka: "スリランカ",
  svk: "スロバキア",
  svn: "スロベニア",
  swz: "スワジランド",
  sdn: "スーダン",
  sen: "セネガル",
  srb: "セルビア",
  kna: "セントクリストファー・ネイビス",
  vct: "セントビンセントおよびグレナディーン諸島",
  shn: "セントヘレナ、アセンションおよびトリスタンダクーニャ",
  lca: "セントルシア",
  syc: "セーシェル",
  som: "ソマリア",
  slb: "ソロモン諸島",
  tha: "タイ",
  tjk: "タジキスタン",
  tza: "タンザニア",
  tca: "タークス・カイコス諸島",
  cze: "チェコ",
  tcd: "チャド",
  tun: "チュニジア",
  chl: "チリ",
  tuv: "ツバル",
  dnk: "デンマーク",
  tkl: "トケラウ",
  tto: "トリニダード・トバゴ",
  tkm: "トルクメニスタン",
  tur: "トルコ",
  ton: "トンガ",
  tgo: "トーゴ",
  dma: "ドミニカ",
  dom: "ドミニカ共和国",
  nga: "ナイジェリア",
  nru: "ナウル",
  nam: "ナミビア",
  niu: "ニウエ",
  nic: "ニカラグア",
  ner: "ニジェール",
  ncl: "ニューカレドニア",
  nzl: "ニュージーランド",
  npl: "ネパール",
  nor: "ノルウェー",
  nfk: "ノーフォーク島",
  hti: "ハイチ",
  hun: "ハンガリー",
  hmd: "ハード島とマクドナルド諸島",
  vat: "バチカン市国",
  vut: "バヌアツ",
  bhs: "バハマ",
  bmu: "バミューダ",
  brb: "バルバドス",
  bgd: "バングラデシュ",
  bhr: "バーレーン",
  pak: "パキスタン",
  pan: "パナマ",
  png: "パプアニューギニア",
  plw: "パラオ",
  pry: "パラグアイ",
  pse: "パレスチナ",
  pcn: "ピトケアン諸島",
  fji: "フィジー",
  phl: "フィリピン",
  fin: "フィンランド",
  fro: "フェロー諸島",
  flk: "フォークランド（マルビナス）諸島",
  guf: "フランス領ギアナ",
  pyf: "フランス領ポリネシア",
  atf: "フランス領南方・南極地域",
  bra: "ブラジル",
  bgr: "ブルガリア",
  bfa: "ブルキナファソ",
  brn: "ブルネイ・ダルサラーム",
  bdi: "ブルンジ",
  btn: "ブータン",
  bvt: "ブーベ島",
  pri: "プエルトリコ",
  vnm: "ベトナム",
  ben: "ベナン",
  ven: "ベネズエラ（ボリバリアン共和国）",
  blr: "ベラルーシ",
  blz: "ベリーズ",
  bel: "ベルギー",
  per: "ペルー",
  hnd: "ホンジュラス",
  bih: "ボスニア・ヘルツェゴビナ",
  bwa: "ボツワナ",
  bes: "ボネール、シント・ユースタティウスおよびサバ",
  bol: "ボリビア（多民族国）",
  prt: "ポルトガル",
  pol: "ポーランド",
  mac: "マカオ",
  mdg: "マダガスカル",
  myt: "マヨット",
  mwi: "マラウイ",
  mli: "マリ",
  mlt: "マルタ",
  mtq: "マルティニーク",
  mys: "マレーシア",
  imn: "マン島",
  mhl: "マーシャル諸島",
  fsm: "ミクロネシア連邦",
  mmr: "ミャンマー",
  mex: "メキシコ",
  moz: "モザンビーク",
  mco: "モナコ",
  mdv: "モルディブ",
  mda: "モルドバ共和国",
  mar: "モロッコ",
  mng: "モンゴル",
  mne: "モンテネグロ",
  msr: "モントセラト",
  mus: "モーリシャス",
  mrt: "モーリタニア",
  jor: "ヨルダン",
  lao: "ラオス人民民主共和国",
  lva: "ラトビア",
  ltu: "リトアニア",
  lie: "リヒテンシュタイン",
  lby: "リビア",
  lbr: "リベリア",
  lux: "ルクセンブルク",
  rwa: "ルワンダ",
  rou: "ルーマニア",
  lso: "レソト",
  lbn: "レバノン",
  reu: "レユニオン",
  rus: "ロシア連邦",
  chn: "中国",
  caf: "中央アフリカ共和国",
  mkd: "北マケドニア",
  mnp: "北マリアナ諸島",
  zaf: "南アフリカ",
  ssd: "南スーダン",
  ata: "南極",
  umi: "合衆国領有小離島",
  prk: "朝鮮民主主義人民共和国",
  tls: "東ティモール",
  iot: "英領インド洋地域",
  esh: "西サハラ",
  gnq: "赤道ギニア",
  hkg: "香港",
  zzz: "その他",
} as const;
